import { BookingProcessProgressBar } from 'fitbeat.models';
import { BookingSteps } from '../../logic/bookings';

export class BookingProcessInfo {
  public readonly bookingStep: BookingSteps;
  public readonly progressBar?: BookingProcessProgressBar;
}
